import { useContext } from 'react';
import { AuthContext } from 'context';
import { DICTONARY } from 'const/Dictonary';
import { ObtieneUltimaTransaccion } from 'views/Transaccion/utils';
import { PERMISOS } from 'const/Permisos';

export const useOcultaMuestraBotones = () => {
  const {
    perfiles: { isRecicladorDeBase, isOferente, isDemandante },
    sucursalNoAdministrada,
    isTienePermisos
  } = useContext(AuthContext);
  const handleMostrarBotonResumenTransaccion = transaccion => {
    const transaccionesPermitidas = DICTONARY.TRANSACCIONES_PERMITIDAS;
    return transaccionesPermitidas.includes(
      transaccion.transaccionEstado.codigoEstado
    );
  };

  const muestraOcultaBotonCerrarTransaccion = (
    codigoTransaccion,
    transaccionEstado,
    transaccion,
    esDelMismoNegocio,
    transaccionCoincidePermisos
  ) => {
    if (!codigoTransaccion) return;

    if (!isTienePermisos(PERMISOS.cerrarTransaccion)) {
      return false;
    }
    const ultimoEstado = ObtieneUltimaTransaccion(
      codigoTransaccion,
      transaccionEstado
    );

    const isRoleOferente =
      transaccion.infoOferente.nombre ===
      sucursalNoAdministrada.sucursal.empresa.nombreEmpresa; //TODO: VERIFICAR
    const isRoleDemandante =
      transaccion.infoDemandante.nombre ===
      sucursalNoAdministrada.sucursal.empresa.nombreEmpresa; // TODO: VERIFICAR

    const estadosOferente = [
      DICTONARY.ESTADOS_TRANSACCION[1].CODIGO,
      DICTONARY.ESTADOS_TRANSACCION[2].CODIGO,
      DICTONARY.ESTADOS_TRANSACCION[3].CODIGO
    ];

    const estadosDemandante = [
      DICTONARY.ESTADOS_TRANSACCION[1].CODIGO,
      DICTONARY.ESTADOS_TRANSACCION[4].CODIGO,
      DICTONARY.ESTADOS_TRANSACCION[5].CODIGO
    ];

    const estadosAdmin = esDelMismoNegocio
      ? [
          ...estadosOferente,
          DICTONARY.ESTADOS_TRANSACCION[4].CODIGO,
          DICTONARY.ESTADOS_TRANSACCION[5].CODIGO
        ]
      : [DICTONARY.ESTADOS_TRANSACCION[1].CODIGO];

    const estadosAcesorCircularidad = transaccionCoincidePermisos
      ? [
          ...estadosOferente,
          DICTONARY.ESTADOS_TRANSACCION[4].CODIGO,
          DICTONARY.ESTADOS_TRANSACCION[5].CODIGO
        ]
      : [DICTONARY.ESTADOS_TRANSACCION[1].CODIGO];

    if (isRoleOferente && estadosOferente.includes(ultimoEstado.codigoEstado)) {
      return estadosOferente.includes(ultimoEstado.codigoEstado);
    }

    if (
      isRoleDemandante &&
      estadosDemandante.includes(ultimoEstado.codigoEstado)
    ) {
      return estadosDemandante.includes(ultimoEstado.codigoEstado);
    }

    if (
      isRecicladorDeBase ||
      (isTienePermisos(PERMISOS.administracionSucursales) &&
        !transaccionCoincidePermisos)
    ) {
      return estadosAdmin.includes(ultimoEstado.codigoEstado);
    }

    if (transaccionCoincidePermisos) {
      return estadosAcesorCircularidad.includes(ultimoEstado.codigoEstado);
    }
    return false;
  };

  const muestraOcultaBotonGuardarResiduo = (
    codigoTransaccion,
    transaccionEstado
  ) => {
    // TODO: preguntar si aplica este boton para usuarios asesor de circularidad
    //El usuario no tiene permisos para guardar un residuo.
    if (!isDemandante && !isOferente && !isRecicladorDeBase) {
      return false;
    }

    //El residuo no tiene los datos suficientes para guardar el residuo
    if (!codigoTransaccion) return;
    const ultimoEstado = ObtieneUltimaTransaccion(
      codigoTransaccion,
      transaccionEstado
    );
    //El residuo debe solo permitir guardarse dependiendo del estado final de la transacción.
    if (ultimoEstado.codigoEstado === DICTONARY.ESTADOS_TRANSACCION[6].CODIGO)
      return true;
    else {
      return false;
    }
  };
  return {
    handleMostrarBotonResumenTransaccion,
    muestraOcultaBotonCerrarTransaccion,
    muestraOcultaBotonGuardarResiduo
  };
};
